//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"

export default {
  name: 'Track',
  components: {
  },
  data: function() {
    return {
      patterns: []
    }
  },
  methods: {
    getTrackMetadata: async function(done) {
        done();
    }
  },
  mounted: function() {
    this.refreshFiles();
  }
}
